import { createFileRoute } from '@tanstack/react-router'
import SecurityPage from '@/components/Security'

export const Route = createFileRoute('/_authenticated/security/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SecurityPage />
}
